import React from "react";
import TextField from '@material-ui/core/TextField';
import {Card, CardActions, CardContent} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CircularProgress from '@material-ui/core/CircularProgress';
import {importacionesResources} from "../endpoints";
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';

class CardImportar extends React.Component{
    state ={
        file : "",
        open: false,
        progress: false,
        disabled: false,
        severity: null,
        message: null
    }

    handleOnFileChange = (e) => {
        let file = e.target.files[0];
        this.setState({
            [e.target.id] : file
        })
    }
    submitForm = () => {
        this.setState({progress:true,disabled:true, open:false})
        const formData = new FormData();
        formData.append("file",this.state.file);
        const date = this.state.file.lastModified
        importacionesResources.importarFalabella(formData,this.props.endpoint, date).then( async response => {
            if(response){
                return await response.json()
            }
        }).then( result => {
            if(result.message){
                this.setState({
                    progress:false,
                    open: true,
                    message: result.message,
                    severity: result.severity,
                    disabled:false})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.error(error);
            this.setState({
                progress:false,
                open: true,
                message: "Ha ocurrido un error inesperado",
                severity: "error",
                disabled:false})
        });
        setTimeout(() => {
            // After 3 seconds set the show value to false
            this.setState({open:false})
        }, 6000)
    }

    render() {
        return(
            <Card style={{display: 'inline-grid'}}>
                <Typography style={{marginLeft:'16px', marginTop:'16px'}} variant={'h5'}>{this.props.title}</Typography>
                <CardContent>
                    <TextField
                        inputProps={{ accept: this.props.extension }}
                        disabled={this.state.disabled}
                        style={{width:'auto'}}
                        type={"file"}
                        id="file"
                        label="Seleccione archivo"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        onChange={this.handleOnFileChange}
                    />
                </CardContent>
                {this.state.progress ? <CircularProgress style={{display: 'inline-grid', justifySelf: 'center'}}/>: null}
                <CardActions>
                    <Button disabled={!this.state.file || this.state.disabled} variant="contained" color={'primary'} onClick={this.submitForm}>
                        Subir archivo
                    </Button>
                </CardActions>
                {this.state.open?
                    <Collapse in={this.state.open}>
                        <Alert
                            variant="filled"
                            severity={this.state.severity}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        this.setState({open: false});
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            {this.state.message}
                        </Alert>
                    </Collapse> : null}
            </Card>
        )
    }
}

export default CardImportar;